import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import '../../../../modules/app/scss/style.scss';

import {
    Filter,
    FilterGroup,
    Table,
    Title,
    Tbody,
    Thead,
    Toolbox,
    Tr,
    Pagination,
    Button
} from 'table';
import T from 'modules/i18n';
import { requestData, getData as getListData, getInfo } from 'core/ducks/list';
import Loading from '../../../../core/components/loading';
import withOrganizations from './withOrganizations';

class Messages extends Component {
    constructor(props) {
        super(props);
        this.initialState = {
            page: 1,
            refreshing: false,
            query: '',
            status: '',
            sort: 'created_at',
            sort_method: 'desc',
            httpStatus: 200
        };

        const { params } = props.match;

        const initialize = {
            status: params && params.status ? params.status : ''
        };

        this.fields = ['primary_registry', 'organization', 'attachments', 'read'];
        this.layout = {
            read: { type: 'boolean', sortable: false },
            attachments: { sortable: false },
            organization: { sortable: false },
            primary_registry: { sortable: false }
        };

        this.state = {
            ...this.initialState,
            ...initialize,
            page: 1,
            refreshing: false,
            isMessageModalOpen: false,
            activeMessageContent: {},
            messages: {},
            activeProfile: props.activeProfile
        };
    }

    componentDidMount() {
        this.fetchMessages();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.activeProfile !== this.props.activeProfile) {
            this.setState({ activeProfile: this.props.activeProfile }, this.fetchMessages);
        }
        if (
            prevState.page !== this.state.page ||
            prevState.query !== this.state.query ||
            prevState.sort !== this.state.sort ||
            prevState.sort_method !== this.state.sort_method
        ) {
            this.fetchMessages();
        }
    }

    fetchMessages = () => {
        const url = this.createUrl();
        if ( url )
        {this.props
            .dispatch(requestData('messages', url))
            .then(response => {
                const {
                    values: messages,
                    limit,
                    page,
                    total_pages,
                    query,
                    filter_query
                } = response;
                this.setState({
                    messages,
                    limit,
                    page,
                    total_pages,
                    query,
                    filter_query
                });
            })
            .catch(httpStatus => {
                this.setState({ httpStatus });
            });}
    };

    createUrl = (base_url = 'appmessages/message/user/all') => {
        let { query, sort, sort_method, activeProfile } = this.state;
        if (activeProfile)
        {console.log('active profile '+ activeProfile);
        let url =
            base_url === 'appmessages/message/user/all'
                ? `${base_url}/page/${this.state.page}`
                : base_url;
        url = `${url}/sort/${sort}/sort_method/${sort_method}`;
        query = query !== '' ? '/query/' + query : '';
        url += query;
        let fq = '';
        fq += activeProfile && activeProfile !== '' ? 'organization:' + activeProfile : '';
        fq = fq !== '' ? '/fq/' + fq : fq;
        url += query + fq;

        return url;}
    };

    handlePageChange = page => {
        this.setState({ page }, this.fetchMessages);
    };

    handleSortChange = sort => {
        if (sort === this.state.sort) {
            this.setState(
                { sort_method: this.state.sort_method === 'asc' ? 'desc' : 'asc' },
                this.fetchMessages
            );
        } else {
            this.setState({ sort }, this.fetchMessages);
        }
    };

    redirectToApplication = message => {
        const { round, app_uuid } = message;
        this.props.history.push(`/app/apply/${round}/${app_uuid}`);
    };

    render() {
        const { messages } = this.state;
        return (
            <Col>
                <Row>
                    <Col>
                        <Table>
                            <Thead>
                                <Tr
                                    className="text"
                                    data={['', ...this.fields]}
                                    layout={{ ...this.layout }}
                                    sortBy={this.state.sort}
                                    sortMethod={this.state.sort_method}
                                    onClick={this.handleSortChange}
                                />
                            </Thead>
                            {this.props.pending ? (
                                <Loading />
                            ) : (
                                <Tbody refreshing={this.state.refreshing}>
                                    {messages ? (
                                        <Tr
                                            data={messages}
                                            layout={{ ...this.layout }}
                                            order={[...this.fields]}>
                                            {this.state.activeProfile ? (
                                                <Button
                                                    type="view"
                                                    title=""
                                                    onClick={message => {
                                                        this.redirectToApplication(message);
                                                    }}
                                                />
                                            ) : (
                                                <Button
                                                    type="view"
                                                    title=""
                                                    style={{ visibility: 'hidden' }}
                                                />
                                            )}
                                        </Tr>
                                    ) : (
                                        <Tr />
                                    )}
                                </Tbody>
                            )}
                        </Table>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col>
                        <Pagination
                            className="mx-auto"
                            page={this.state.page}
                            total={this.state.total_pages}
                            onClick={page => {
                                if (page !== this.state.page) this.handlePageChange(page);
                            }}
                        />
                    </Col>
                </Row>
            </Col>
        );
    }
    
}

export default withOrganizations(Messages);
